var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("publicHeader"),
      _c("el-main", [
        _c(
          "div",
          { staticClass: "forgot" },
          [
            _c("router-link", { attrs: { to: { name: "sign_in" } } }, [
              _c("i", { staticClass: "el-icon-back" }, [
                _vm._v(_vm._s(_vm.$t("sign_in.back_signin"))),
              ]),
            ]),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  "label-position": "top",
                  "label-width": "100px",
                  model: _vm.form,
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("sign_in.email"),
                      prop: "email",
                      clearable: "",
                    },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.forgot } },
                  [_vm._v(_vm._s(_vm.$t("sign_in.forgot")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }